import { truncateMiddle } from "@utils/utilsString";
import { EditionSession } from "./types";

export const getSessionLink = (session: EditionSession): string =>
  session.url || session.link || "";

export const truncateLink = (link: string): string => truncateMiddle(link);

export const isAbsoluteHttpLink = (link: string): boolean =>
  /^https?:\/\//i.test(link);

export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (!text || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
